import { useMap, MAPBOX_KEY } from './chunk-DNUFCL26.js';
import { useDefaultLocation } from './chunk-SBDRB6T7.js';
import { useTokens } from '@gemini/core';
import { isEmpty } from 'lodash';
import { useFormContext } from 'react-hook-form';

var radiusToZoom = {
  0: 10,
  1: 12.25,
  2: 11.25,
  3: 10.65,
  5: 9.9,
  10: 8.9,
  15: 8.4,
  20: 8,
  25: 7.6,
  30: 7.4,
  50: 6.6
};
var useRadiusMap = ({ locationIndex }) => {
  const {
    "color.content.status.information.default": contentColor,
    "color.border.status.information.default": borderColor,
    "color.background.default": defaultColor
  } = useTokens();
  const { watch } = useFormContext();
  const { coordinates: defaultCoordinates } = useDefaultLocation();
  const location = watch("locations")?.[locationIndex];
  const center = isEmpty(location?.coordinates) ? defaultCoordinates : location.coordinates;
  const radius = location?.radius ?? 3;
  return useMap({
    accessToken: MAPBOX_KEY,
    radius,
    colors: {
      content: contentColor,
      border: borderColor,
      default: defaultColor
    },
    center,
    zoom: radiusToZoom[radius]
  });
};

export { useRadiusMap };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-J3DBQDBT.js.map